<div class="settings">
  <div class="settings-header">
    <app-button btnType="icon" (onChangeClick)="closeLeftMenu()">
      <app-icon>arrow_back</app-icon>
    </app-button>
    <span class="text-truncate">{{ selectedSubSetting?.title || 'settings' | translate }}</span>
    <div class="flex-fill"></div>
  </div>

  @if (!selectedSubSetting?.key) {
    <div class="settings-content">
      @if (settingsItems && Object.keys(settingsItems).length) {
        <div class="settings-content-block settings-main-menu">
          @for (item of settingsItems; track $index) {
            <div matRipple (click)="item.action(item)" class="settings-item click-css">
              @if (item.is_svg) {
                <app-icon [svgIcon]="item.icon" />
              } @else {
                <app-icon>{{ item.icon }}</app-icon>
              }
              <span class="text-truncate">{{ item.title | translate }}</span>
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <ng-container *ngTemplateOutlet="subSetting" />
  }
</div>

<ng-template #subSetting>
  @switch ($safeNavigationMigration(selectedSubSetting?.key)) {
    @case (SUB_SETTINGS.GENERAL_SETTINGS) {
      <div class="settings-content-block">
        <span class="settings-content-title">{{ 'chat_settings.keyboard' | translate }}</span>
        <label class="settings-item click-css" matRipple>
          <app-radio
            [formControl]="settingsForm.controls.keyboard"
            (onValueChange)="changeSettings(SETTINGS_KEYS.HOT_KEY_SEND_CHAT, $event)"
            [value]="KEYBOARD.ENTER"
          >
          </app-radio>
          <div class="settings-item-title-wrapper">
            {{ 'chat_settings.enter_send' | translate }}
            <span class="settings-item-tooltip">{{ 'chat_settings.new_line_shift_enter' | translate }}</span>
          </div>
        </label>
        <label class="settings-item click-css" matRipple>
          <app-radio
            [formControl]="settingsForm.controls.keyboard"
            (onValueChange)="changeSettings(SETTINGS_KEYS.HOT_KEY_SEND_CHAT, $event)"
            [value]="KEYBOARD.CMD_ENTER"
          >
          </app-radio>
          <div class="settings-item-title-wrapper">
            @if (isMacOS()) {
              <span>{{ 'chat_settings.cmd_enter_send' | translate }}</span>
            } @else {
              <span>{{ 'chat_settings.ctrl_enter_send' | translate }}</span>
            }
            <span class="settings-item-tooltip">{{ 'chat_settings.new_line_enter' | translate }}</span>
          </div>
        </label>
        <label class="settings-item click-css" matRipple>
          <app-radio
            [formControl]="settingsForm.controls.keyboard"
            (onValueChange)="changeSettings(SETTINGS_KEYS.HOT_KEY_SEND_CHAT, $event)"
            [value]="KEYBOARD.SHIFT_ENTER"
          >
          </app-radio>
          <div class="settings-item-title-wrapper">
            {{ 'chat_settings.shift_enter_send' | translate }}
            <span class="settings-item-tooltip">{{ 'chat_settings.new_line_enter' | translate }}</span>
          </div>
        </label>
      </div>
      <div class="settings-content-block">
        <span class="settings-content-title">{{ 'chat_settings.notifications' | translate }}</span>
        <label class="settings-item click-css" matRipple>
          <app-checkbox
            [formControl]="settingsForm.controls.is_message_read"
            (change)="changeSettings(SETTINGS_KEYS.IS_MESSAGE_READ, $event)"
          />
          <div class="settings-item-title-wrapper">
            {{ 'chat_settings.mark_as_read' | translate }}
            <span class="settings-item-tooltip">
              @if (settingsForm.controls.is_message_read.value) {
                {{ 'chat_settings.enabled' | translate }}
              } @else {
                {{ 'chat_settings.disabled' | translate }}
              }
            </span>
          </div>
        </label>
      </div>
      <div class="settings-content-block">
        <span class="settings-content-title">{{ 'chat_settings.other' | translate }}</span>
        <label class="settings-item click-css" matRipple>
          <app-checkbox
            [formControl]="settingsForm.controls.is_lazy_loading"
            (change)="changeSettings(SETTINGS_KEYS.IS_LAZY_LOADING, $event)"
          />
          <div class="settings-item-title-wrapper">
            {{ 'chat_settings.lazy_loading' | translate }}
            <span class="settings-item-tooltip">
              @if (settingsForm.controls.is_lazy_loading.value) {
                {{ 'chat_settings.enabled' | translate }}
              } @else {
                {{ 'chat_settings.disabled' | translate }}
              }
            </span>
          </div>
        </label>
        <label class="settings-item click-css" matRipple>
          <app-checkbox
            [formControl]="settingsForm.controls.is_chat_unpin"
            (change)="changeSettings(SETTINGS_KEYS.IS_CHAT_UNPIN, $event)"
          />
          <div class="settings-item-title-wrapper">
            {{ 'chat_settings.chat_unpin' | translate }}
            <span class="settings-item-tooltip">
              @if (settingsForm.controls.is_chat_unpin.value) {
                {{ 'chat_settings.enabled' | translate }}
              } @else {
                {{ 'chat_settings.disabled' | translate }}
              }
            </span>
          </div>
        </label>
      </div>
    }
    @case (SUB_SETTINGS.BLOCKED_USERS) {
      <div class="settings-content-block overflow-auto crm-scroll">
        @if (!(chatService.blockedUsers && chatService.blockedUsers.length)) {
          <span class="no-results">
            {{ 'chat_settings.no_blocked_users' | translate }}
          </span>
        }

        @for (user of chatService.blockedUsers; track user.user_id) {
          <div class="settings-item">
            <app-button btnType="icon" (onChangeClick)="unblockUser(user.user_id, user.type)" [matTooltip]="'unblock' | translate">
              <app-icon>no_encryption</app-icon>
            </app-button>
            @if (entityIcons[user.type]) {
              <img
                class="h-5 w-5 shrink-0 rounded-full object-cover"
                [src]="entityIcons[user.type]"
                [alt]="user.type"
                [matTooltip]="user.type"
              />
            }
            <span class="fw-500 text-truncate">{{ user.name }}</span>
          </div>
        }
      </div>
    }
    @case (SUB_SETTINGS.FAST_REPLY) {
      <div class="d-flex flex-column overflow-auto crm-scroll">
        <div class="settings-content-block">
          <span class="settings-content-title">{{ 'chat_settings.add_fast_replies' | translate }}</span>
          <div class="settings-item-replies">
            <app-textarea
              #replyInput
              class="w-100 crm-scroll"
              placeholder="{{ 'write_a_message' | translate }}..."
              [formControl]="textAreaControl"
            />
            <div class="d-flex w-100 gap-2">
              <div class="settings-item-replies-button" (click)="cancel()">
                {{ 'cancel' | translate }}
              </div>
              <div class="flex-fill"></div>
              @if (isUpdate) {
                <div class="settings-item-replies-button" (click)="update()">
                  {{ 'change' | translate }}
                </div>
              } @else {
                <div class="settings-item-replies-button" (click)="save()">
                  {{ 'save' | translate }}
                </div>
              }
            </div>
          </div>
        </div>
        <div class="settings-content-block">
          <span class="settings-content-title">{{ 'chat_settings.saved_fast_replies' | translate }}</span>
          @if (!(replies && replies.length)) {
            <span class="no-results">
              {{ 'chat_settings.no_replies' | translate }}
            </span>
          }
          <div cdkDropList (cdkDropListDropped)="dropReply($event)">
            @for (reply of replies; track reply.id) {
              <div class="settings-content overflow-auto crm-scroll" cdkDrag>
                <div class="settings-item justify-content-between w-100 overflow-hidden">
                  <div class="d-flex align-items-center gap-2">
                    <app-button btnType="icon" cdkDragHandle>
                      <app-icon>drag_indicator</app-icon>
                    </app-button>
                    <span class="reply-text">{{ reply.text }}</span>
                  </div>
                  <div class="d-flex">
                    <app-button btnType="icon" (click)="editTemplate(reply)">
                      <app-icon>edit</app-icon>
                    </app-button>
                    <app-button btnType="icon" (click)="delete(reply)">
                      <app-icon>delete</app-icon>
                    </app-button>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
    @case (SUB_SETTINGS.CHAT_TAGS) {
      <div class="flex min-h-0 flex-1 flex-col gap-3 overflow-hidden p-2">
        @if (canManageTags) {
          <section class="shrink-0 rounded-xl bg-white p-4 shadow-sm">
            <div class="flex flex-wrap items-end gap-3" [formGroup]="tagForm">
              <div class="min-w-[220px] flex-1">
                <app-input
                  #tagNameInput
                  [formControl]="tagForm.controls.name"
                  (keydown.enter)="submitTagForm($event)"
                  [placeholder]="'tag_name' | translate"
                />
              </div>
              <div class="flex flex-col gap-1">
                <span class="text-xs font-medium text-slate-500">{{ 'color' | translate }}</span>
                <app-color
                  class="inline-block w-11"
                  [input]="tagForm.controls.color.value"
                  [formControl]="tagForm.controls.color"
                  [colors]="colors"
                />
              </div>
              <div class="flex flex-wrap gap-2">
                <app-button [disabled]="tagForm.invalid || isSavingTag" (onChangeClick)="saveTag()">
                  {{ (editingTagId ? 'save' : 'add') | translate }}
                </app-button>
                @if (editingTagId) {
                  <app-button btnType="stroked" (onChangeClick)="resetTagForm()">
                    {{ 'cancel' | translate }}
                  </app-button>
                }
              </div>
            </div>
          </section>
        }

        <section class="min-h-0 flex-1 overflow-hidden rounded-xl bg-white p-2 shadow-sm">
          @if (tags.length) {
            <div class="crm-scroll h-full overflow-y-auto">
              <div class="divide-y divide-slate-100">
                @for (tag of tags; track tag.id) {
                  <div
                    class="flex min-h-14 items-center gap-3 rounded-lg px-3 py-2 transition-colors hover:bg-slate-50"
                  >
                    <span class="h-3 w-3 shrink-0 rounded-full" [style.background-color]="tag.color"></span>
                    <span class="min-w-0 flex-1 truncate text-sm font-medium text-slate-800">{{ tag.name }}</span>
                    @if (canManageTags) {
                      <div class="flex shrink-0 items-center gap-1">
                        <app-button btnType="icon" (onChangeClick)="editTag(tag)"><app-icon>edit</app-icon></app-button>
                        <app-button btnType="icon" (onChangeClick)="deleteTag(tag)"
                          ><app-icon>delete</app-icon></app-button
                        >
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          } @else {
            <span class="block p-6 text-center text-sm text-slate-500">{{ 'no_tags' | translate }}</span>
          }
        </section>
      </div>
    }
  }
</ng-template>
